
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M39.82 23.55c0-1.63-1.55-4.39-2.04-5.31-.5-.92-2.55-4.88-2.55-6.79V9.11h-10.7v2.34c0 1.91-2.05 5.87-2.55 6.79-.5.92-1.98 3.68-1.98 5.31v25.69c0 2.89 2.35 5.24 5.24 5.24h9.34c2.89 0 5.24-2.35 5.24-5.24V23.55zM36.28 6H23.55a.5.5 0 00-.5.5v2.11a.5.5 0 00.5.5h12.73a.5.5 0 00.5-.5V6.5a.5.5 0 00-.5-.5z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M39.82 27.19H26.75v15.94h13.07V27.19z"}})])
          )
        }
      }
    